export class VendorIdRequest{
    vendorId: number;
    constructor(vendorId: number){
        this.vendorId = vendorId;
    }
}